import { OpeningHoursDay } from './OpeningHoursDay';
import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class OpeningHours {

  /**
   * closed <=> same consumption as the during the night!
   * @param dayOfTheWeek 0..6 0 = sunday
   * @param hour 0..23
   */
  public static getHourWeight(openingHours: OpeningHours, dayOfTheWeek: number, hour: number, nightPercentage: number): number {
    // not very optimized when called 8760 times - maybe this monday, tuesday, wednesday... thing should be changed...
    const openingHoursDay: OpeningHoursDay | null = openingHours.hasOnlyTypicalDay ? openingHours.typicalDay : ([openingHours.sunday, openingHours.monday, openingHours.tuesday,
      openingHours.wednesday, openingHours.thursday, openingHours.friday, openingHours.saturday][dayOfTheWeek] ||
      openingHours.typicalDay);

    if (openingHoursDay == null) {
      throw new Error('Could not determine hour weight!');
    }

    if (openingHoursDay.isClosed) {
      return nightPercentage;
    }

    if (openingHoursDay.openingHour == null || openingHoursDay.closingHour == null) {
      throw new Error('OpeningHours not closed must have openingHour and closingHour defined!');
    }

    if (openingHoursDay.openingHour >= 24) {
      throw new Error('openingHour must be lower than 24');
    }

    // if openingHoursDay.openingHour == openingHoursDay.closingHour then nightPercentage as there is no opening
    return ((openingHoursDay.openingHour < openingHoursDay.closingHour && hour >= openingHoursDay.openingHour && hour < openingHoursDay.closingHour) ||
      (openingHoursDay.openingHour > openingHoursDay.closingHour && (hour >= openingHoursDay.openingHour || hour < openingHoursDay.closingHour)))
      ? 1 : nightPercentage;
  }

  public hasOnlyTypicalDay: boolean | null = null;

  public typicalDay: OpeningHoursDay | null = null;

  public sunday: OpeningHoursDay | null = null;

  public monday: OpeningHoursDay | null = null;

  public tuesday: OpeningHoursDay | null = null;

  public wednesday: OpeningHoursDay | null = null;

  public thursday: OpeningHoursDay | null = null;

  public friday: OpeningHoursDay | null = null;

  public saturday: OpeningHoursDay | null = null;

  public constructor(obj: ObjectOnly = {}) {
    assignToThis(this, obj);

    this.typicalDay = this.typicalDay ? new OpeningHoursDay(this.typicalDay) : null;

    this.sunday = this.sunday ? new OpeningHoursDay(this.sunday) : null;

    this.monday = this.monday ? new OpeningHoursDay(this.monday) : null;

    this.tuesday = this.tuesday ? new OpeningHoursDay(this.tuesday) : null;

    this.wednesday = this.wednesday ? new OpeningHoursDay(this.wednesday) : null;

    this.thursday = this.thursday ? new OpeningHoursDay(this.thursday) : null;

    this.friday = this.friday ? new OpeningHoursDay(this.friday) : null;

    this.saturday = this.saturday ? new OpeningHoursDay(this.saturday) : null;
  }

}
